import {
    ACCOUNT_TYPE_MAPPING_ADMIN_SUCCESS,
    ACCOUNT_TYPE_MAPPING_ADMIN_FAILED,
    LOADING_ACCOUNT_TYPE_MAPPING_ADMIN,
    NETWORK_ERROR_TYPE_MAPPING_ADMIN
} from "../types/index";
import { adminServices } from "../../config/axios";

const accountTypeMappingAdmin =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_ACCOUNT_TYPE_MAPPING_ADMIN });
        await adminServices
            .post("addaccttypeadminmapping", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: ACCOUNT_TYPE_MAPPING_ADMIN_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: ACCOUNT_TYPE_MAPPING_ADMIN_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_TYPE_MAPPING_ADMIN,
                    payload: err
                });
            });
    };

export { accountTypeMappingAdmin };
